//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import proseText from '~/mixins/proseText'
export default {
  mixins: [proseText],
  inheritAttrs: false,
  props: {
    title: {
      type: String,
      default: '',
      required: false,
    },
    label: {
      type: String,
      default: '',
    },
    backgroundColor: {
      type: String,
      default: '',
    },
    mentorsProfile: {
      type: Array,
      default() {},
    },
    content: {
      type: Object,
      default() {},
    },
    buttons: {
      type: Array,
      default() {},
    },
    horizontalOrientation: {
      type: Boolean,
      default: true,
    },
    isHomepage: {
      type: Boolean,
      default: false,
    },
    dataIndex: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      illustrations: [
        {
          number: 1,
          src: require(`~/assets/img/element-hear-05.svg?data`),
          width: 274,
          height: 184,
          alt: '',
        },
        {
          number: 2,
          src: require(`~/assets/img/element-learn-06.svg?data`),
          width: 222,
          height: 457,
          alt: '',
        },
        {
          number: 3,
          src: require(`~/assets/img/element-connect-08.svg?data`),
          width: 184,
          height: 151,
          alt: '',
        },
        {
          number: 4,
          src: require(`~/assets/img/element-hear-05.svg?data`),
          width: 274,
          height: 184,
          alt: '',
        },
        {
          number: 5,
          src: require(`~/assets/img/element-connect-06.svg?data`),
          width: 164,
          height: 139,
          alt: '',
        },
      ],
    }
  },
  computed: {
    ilustrationsToShow() {
      if (this.horizontalOrientation) {
        return this.illustrations.slice(0, 1)
      } else {
        return this.illustrations.slice(1, 5)
      }
    },
  },
  methods: {
    reversePosition(position) {
      if (position === 'left') return 'right'
      if (position === 'right') return 'left'
      return 'center'
    },
  },
}
